import React, {useEffect, useRef, useState} from 'react';
import './StickyElementTop.less';

export const StickyElementTop = ({children}) => {
	const [isSticky, setSticky] = useState(false);
	const container = useRef(null);

	useEffect(() => {
		//sticky element must have top: -1px;
		const observer = new IntersectionObserver(([e]) => setSticky(e.intersectionRatio < 1), {threshold: [1]});

		observer.observe(container.current);

		return () => {
			observer.unobserve(container.current);
		};
	}, []);
	return (
		<div
			className="sticky-element-top"
			ref={container}>
			{children(isSticky)}
		</div>
	);
};
